import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './Unknown.scss';
export const Unknown = ({ width, height })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, t('deviationview.unknown'));
};
Unknown.displayName = 'Unknown';
export default Unknown;
